export const SET_SEARCH_VALUE = 'src/store/example/SET_SEARCH_VALUE';
